import React, { useState } from 'react';
import { Box, Tooltip, Chip } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useTranslation } from 'react-i18next';

// Theme colors - matching Sidebar
const primaryColor = '#5757b0';
const hoverColor = '#7777d0';
const lightPurple = '#f0f0ff';

const TimeEventAttachments = ({ timeevent, navigateTo, onAttachmentClick, maxVisible = null }) => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const attachments = Array.isArray(timeevent?.childs) ? timeevent.childs : [];
  const hasLimit = Number.isFinite(maxVisible) && maxVisible > 0;

  if (attachments.length === 0) return null;

  // Helper function to extract file name and extension
  const getFileName = (source) => {
    return source.split(/[/\\]/).pop();
  };

  const visibleAttachments = hasLimit && !showAll ? attachments.slice(0, maxVisible) : attachments;
  const hiddenCount = hasLimit && !showAll ? attachments.length - visibleAttachments.length : 0;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px', mb: 1 }}>
      {visibleAttachments.map((attachment, index) => (
        <Tooltip key={attachment.id} title={t('timeevent.view_attachment', 'View attachment details')}>
          <Chip
            icon={<AttachFileIcon fontSize="small" />}
            label={getFileName(attachment.source)}
            onClick={() => onAttachmentClick ? onAttachmentClick(attachment.id) : navigateTo(attachment.id)}
            size="small"
            sx={{
              backgroundColor: `${lightPurple}80`,
              color: primaryColor,
              fontSize: '0.75rem',
              borderRadius: '16px',
              transition: 'background-color 0.15s ease, color 0.15s ease',
              '&:hover': {
                backgroundColor: lightPurple,
                color: hoverColor,
              }
            }}
          />
        </Tooltip>
      ))}
      {hiddenCount > 0 && (
        <Chip
          label={t('timeevent.attachments_more', {
            count: hiddenCount,
            defaultValue: `+${hiddenCount} more`
          })}
          size="small"
          onClick={() => setShowAll(true)}
          sx={{
            backgroundColor: `${lightPurple}80`,
            color: primaryColor,
            fontSize: '0.75rem',
            borderRadius: '16px',
            cursor: 'pointer',
            transition: 'background-color 0.15s ease, color 0.15s ease',
            '&:hover': {
              backgroundColor: lightPurple,
              color: hoverColor,
            }
          }}
        />
      )}
      {hasLimit && showAll && attachments.length > maxVisible && (
        <Chip
          label={t('timeevent.attachments_show_less', 'Show less')}
          size="small"
          onClick={() => setShowAll(false)}
          sx={{
            backgroundColor: `${lightPurple}80`,
            color: primaryColor,
            fontSize: '0.75rem',
            borderRadius: '16px',
            cursor: 'pointer',
            transition: 'background-color 0.15s ease, color 0.15s ease',
            '&:hover': {
              backgroundColor: lightPurple,
              color: hoverColor,
            }
          }}
        />
      )}
    </Box>
  );
};

export default React.memo(TimeEventAttachments);
